import type { WritingExpressionItem } from '../writingExpressionBank';

/** French writing scaffolds — discourse relations; shared across French writing exams. */
export const FRENCH_WRITING_EXPRESSIONS: readonly WritingExpressionItem[] = [
  // introduce
  { id: 'fr-introduce-1', category: 'introduce', text: 'Tout d’abord,', gloss: '首先' },
  { id: 'fr-introduce-2', category: 'introduce', text: 'Pour commencer,', gloss: '开始时' },
  { id: 'fr-introduce-3', category: 'introduce', text: 'En guise d’introduction,', gloss: '作为开场' },
  { id: 'fr-introduce-4', category: 'introduce', text: 'Je souhaite aborder…', gloss: '我想谈及…' },
  { id: 'fr-introduce-5', category: 'introduce', text: 'Madame, Monsieur,', gloss: '尊敬的先生/女士（书信开场）' },
  // continue
  { id: 'fr-continue-1', category: 'continue', text: 'Ensuite,', gloss: '接着' },
  { id: 'fr-continue-2', category: 'continue', text: 'Par ailleurs,', gloss: '另外 / 另一方面' },
  { id: 'fr-continue-3', category: 'continue', text: 'Dans un second temps,', gloss: '其次' },
  { id: 'fr-continue-4', category: 'continue', text: 'Sur ce point,', gloss: '在这一点上' },
  // finally
  { id: 'fr-finally-1', category: 'finally', text: 'Enfin,', gloss: '最后' },
  { id: 'fr-finally-2', category: 'finally', text: 'Pour finir,', gloss: '作为收尾' },
  { id: 'fr-finally-3', category: 'finally', text: 'En dernier lieu,', gloss: '最后一点' },
  // cause_reason
  { id: 'fr-cause-reason-1', category: 'cause_reason', text: 'Parce que', gloss: '因为' },
  { id: 'fr-cause-reason-2', category: 'cause_reason', text: 'Puisque', gloss: '既然' },
  { id: 'fr-cause-reason-3', category: 'cause_reason', text: 'En raison de', gloss: '由于…' },
  { id: 'fr-cause-reason-4', category: 'cause_reason', text: 'Du fait que', gloss: '鉴于…' },
  // cause_result
  { id: 'fr-cause-result-1', category: 'cause_result', text: 'Par conséquent,', gloss: '因此' },
  { id: 'fr-cause-result-2', category: 'cause_result', text: 'C’est pourquoi', gloss: '所以' },
  { id: 'fr-cause-result-3', category: 'cause_result', text: 'Ainsi,', gloss: '这样一来' },
  { id: 'fr-cause-result-4', category: 'cause_result', text: 'De ce fait,', gloss: '由此' },
  // contrast_turn
  { id: 'fr-contrast-turn-1', category: 'contrast_turn', text: 'Cependant,', gloss: '然而' },
  { id: 'fr-contrast-turn-2', category: 'contrast_turn', text: 'Néanmoins,', gloss: '不过' },
  { id: 'fr-contrast-turn-3', category: 'contrast_turn', text: 'Or,', gloss: '然而（论证转折）' },
  { id: 'fr-contrast-turn-4', category: 'contrast_turn', text: 'En revanche,', gloss: '反而 / 相比之下' },
  // contrast_concede
  { id: 'fr-contrast-concede-1', category: 'contrast_concede', text: 'Bien que', gloss: '虽然（+ subj.）' },
  { id: 'fr-contrast-concede-2', category: 'contrast_concede', text: 'Même si', gloss: '即使' },
  { id: 'fr-contrast-concede-3', category: 'contrast_concede', text: 'Certes,… mais…', gloss: '诚然…但是…' },
  { id: 'fr-contrast-concede-4', category: 'contrast_concede', text: 'Il est vrai que…', gloss: '诚然…' },
  // parallel_add
  { id: 'fr-parallel-add-1', category: 'parallel_add', text: 'De plus,', gloss: '此外' },
  { id: 'fr-parallel-add-2', category: 'parallel_add', text: 'En outre,', gloss: '另外' },
  { id: 'fr-parallel-add-3', category: 'parallel_add', text: 'Également,', gloss: '同样' },
  { id: 'fr-parallel-add-4', category: 'parallel_add', text: 'Aussi', gloss: '也' },
  // parallel_choice
  { id: 'fr-parallel-choice-1', category: 'parallel_choice', text: 'Soit… soit…', gloss: '要么…要么…' },
  { id: 'fr-parallel-choice-2', category: 'parallel_choice', text: 'Ou bien', gloss: '或者' },
  { id: 'fr-parallel-choice-3', category: 'parallel_choice', text: 'Autrement', gloss: '否则 / 换种方式' },
  // progressive
  { id: 'fr-progressive-1', category: 'progressive', text: 'Qui plus est,', gloss: '更有甚者' },
  { id: 'fr-progressive-2', category: 'progressive', text: 'Bien plus,', gloss: '更进一步' },
  { id: 'fr-progressive-3', category: 'progressive', text: 'Non seulement… mais aussi…', gloss: '不仅…而且…' },
  // compare
  { id: 'fr-compare-1', category: 'compare', text: 'De même,', gloss: '同样地' },
  { id: 'fr-compare-2', category: 'compare', text: 'Semblablement,', gloss: '类似地' },
  { id: 'fr-compare-3', category: 'compare', text: 'À l’instar de', gloss: '如同…一样' },
  // juxtapose
  { id: 'fr-juxtapose-1', category: 'juxtapose', text: 'Contrairement à…,', gloss: '与…相反' },
  { id: 'fr-juxtapose-2', category: 'juxtapose', text: 'À la différence de…,', gloss: '不同于…' },
  { id: 'fr-juxtapose-3', category: 'juxtapose', text: 'D’un côté… de l’autre…', gloss: '一方面…另一方面…' },
  // exemplify
  { id: 'fr-exemplify-1', category: 'exemplify', text: 'Par exemple,', gloss: '例如' },
  { id: 'fr-exemplify-2', category: 'exemplify', text: 'Notamment', gloss: '尤其是' },
  { id: 'fr-exemplify-3', category: 'exemplify', text: 'Tel que / telle que', gloss: '诸如' },
  { id: 'fr-exemplify-4', category: 'exemplify', text: 'Pour illustrer,', gloss: '举例说明' },
  // exception
  { id: 'fr-exception-1', category: 'exception', text: 'Sauf', gloss: '除…以外' },
  { id: 'fr-exception-2', category: 'exception', text: 'À l’exception de', gloss: '除了…' },
  { id: 'fr-exception-3', category: 'exception', text: 'Hormis', gloss: '除去' },
  // emphasize
  { id: 'fr-emphasize-1', category: 'emphasize', text: 'Il convient de souligner que…', gloss: '需要强调的是…' },
  { id: 'fr-emphasize-2', category: 'emphasize', text: 'En particulier,', gloss: '特别是' },
  { id: 'fr-emphasize-3', category: 'emphasize', text: 'Avant tout,', gloss: '首先 / 尤其' },
  // condition
  { id: 'fr-condition-1', category: 'condition', text: 'Si', gloss: '如果' },
  { id: 'fr-condition-2', category: 'condition', text: 'À condition que', gloss: '条件是（+ subj.）' },
  { id: 'fr-condition-3', category: 'condition', text: 'Dans le cas où', gloss: '倘若' },
  { id: 'fr-condition-4', category: 'condition', text: 'À moins que', gloss: '除非（+ subj.）' },
  // summarize
  { id: 'fr-summarize-1', category: 'summarize', text: 'En conclusion,', gloss: '总之' },
  { id: 'fr-summarize-2', category: 'summarize', text: 'En somme,', gloss: '总而言之' },
  { id: 'fr-summarize-3', category: 'summarize', text: 'Pour conclure,', gloss: '作为总结' },
  { id: 'fr-summarize-4', category: 'summarize', text: 'Pour toutes ces raisons,', gloss: '基于以上理由' },
  // purpose
  { id: 'fr-purpose-1', category: 'purpose', text: 'Afin de', gloss: '为了…' },
  { id: 'fr-purpose-2', category: 'purpose', text: 'Dans le but de', gloss: '目的在于…' },
  { id: 'fr-purpose-3', category: 'purpose', text: 'Pour que', gloss: '为了使…（+ subj.）' },
  // restate
  { id: 'fr-restate-1', category: 'restate', text: 'Autrement dit,', gloss: '换言之' },
  { id: 'fr-restate-2', category: 'restate', text: 'En d’autres termes,', gloss: '换句话说' },
  { id: 'fr-restate-3', category: 'restate', text: 'C’est-à-dire', gloss: '也就是说' },
  // temporal
  { id: 'fr-temporal-1', category: 'temporal', text: 'Puis', gloss: '然后' },
  { id: 'fr-temporal-2', category: 'temporal', text: 'Auparavant,', gloss: '此前' },
  { id: 'fr-temporal-3', category: 'temporal', text: 'Par la suite,', gloss: '随后' },
  { id: 'fr-temporal-4', category: 'temporal', text: 'Au même moment,', gloss: '与此同时' },
  // basis
  { id: 'fr-basis-1', category: 'basis', text: 'Selon', gloss: '根据…' },
  { id: 'fr-basis-2', category: 'basis', text: 'D’après', gloss: '依据…' },
  { id: 'fr-basis-3', category: 'basis', text: 'Au vu de', gloss: '鉴于…' },
  { id: 'fr-basis-4', category: 'basis', text: 'Compte tenu de', gloss: '考虑到…' },
];
